module.exports = __webpack_public_path__ + "img/emptyOrder.5783c0a0.svg";